import { isNotDefined } from '@sgme/fp';
import { Fragment, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useForwardAccumulatorTileId } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { selectForwardAccumulatorProperty } from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const Summary = () => {
  const tileId = useForwardAccumulatorTileId();

  const summary = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'summary'));

  const summaryLines = useMemo(() => summary?.split(/<br\/>|, /) ?? [], [summary]);

  return (
    <div>
      <FormattedMessage id="forwardAccumulator.summary.title" />

      <div data-nodrag data-e2e="summary-text">
        {summary === '' || isNotDefined(summary) ? (
          <FormattedMessage id="forwardAccumulator.summary.placeholder" />
        ) : (
          summaryLines.map((line) => (
            <Fragment key={line}>
              {line}
              <br />
            </Fragment>
          ))
        )}
      </div>
    </div>
  );
};

export default Summary;
